module.exports = "<div class=\"panel panel-primary\">\r\n    <div class=\"panel-heading\">\r\n        Email confirmation\r\n    </div>\r\n    <div class=\"well\" *ngIf='message'>{{message}}\r\n    </div>\r\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./app/accounts/email-confirmation.component.html
 ** module id = 920
 ** module chunks = 0
 **/